export default {
  basic: 'Basic',
  binding: 'Binding',
  events: 'Events',
  slots: 'Slots',
  'lazy-loading': 'Lazy loading'
};



// WEBPACK FOOTER //
// ./demo/services/demos.js